import * as svg from "../../../assets/block-checkout-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const BlockCheckoutIcon = iconBuilder(svg, "BlockCheckoutIcon", "0 0 20 20");
